const DEFAULT_API_PORT = '3001';
const FALLBACK_BASE_URL = `http://localhost:${DEFAULT_API_PORT}`;

const API_BASE_URL = (() => {
  if (typeof window === 'undefined') {
    return FALLBACK_BASE_URL;
  }

  const { protocol, hostname, port } = window.location;
  const resolvedProtocol = protocol || 'http:';
  const resolvedHost = hostname || 'localhost';
  const isLocalHost =
    resolvedHost === 'localhost' || resolvedHost === '127.0.0.1';

  if (isLocalHost) {
    return `${resolvedProtocol}//${resolvedHost}:${DEFAULT_API_PORT}`;
  }

  if (port) {
    return `${resolvedProtocol}//${resolvedHost}:${port}`;
  }

  return `${resolvedProtocol}//${resolvedHost}`;
})();

export { API_BASE_URL };
